import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: 96px;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      gap: 40px;
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column;
      gap: ${theme.v3.spacing.xs};
    }
  `}
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 560px;
  @media (max-width: ${({ theme }) => theme.v3.breakpoints.md}) {
    max-width: 100%;
  }
`;

export const TitleGradient = styled.span`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: 30px;
    font-weight: ${theme.v3.font.weights.bold};
    background: linear-gradient(
      to right,
      ${theme.v3.colors.brand.snappyOrange[60]},
      color-mix(in srgb, ${theme.v3.colors.accent.pink[60]} 50%, ${theme.v3.colors.brand.snappyOrange[60]})
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes['1xlarge']};
    }
  `}
`;

export const Title = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: 30px;
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[5]};

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes['1xlarge']};
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    color: #535862;
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.small};
    }
  `}
`;

export const RightSide = styled.div`
  ${({ theme }) => css`
    flex-shrink: 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  `}
`;

export const CalendarImage = styled.img`
  ${({ theme }) => css`
    display: block;
    max-width: 473px;
    width: 100%;
    height: auto;

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      max-width: 360px;
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      max-width: 500px;
    }
  `}
`;

export const BadgeWrapper = styled.div`
  ${({ theme }) => css`
    margin-bottom: ${theme.v3.spacing.xxxs};
  `}
`;

export const TitleWrapper = styled.div`
  ${({ theme }) => css`
    margin-bottom: ${theme.v3.spacing.xxxs};
  `}
`;

export const DescriptionWrapper = styled.div`
  ${({ theme }) => css`
    margin-bottom: ${theme.v3.spacing.xs};
  `}
`;
